'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import { StyledInterstitial } from '../../../components/chrome/Interstitial/Interstitial'
import { stripLocaleFromPathname } from '../../../lib/routing'

export const Interstitial = () => {
  const pathname = usePathname()
  const searchparams = useSearchParams()
  const [isVisible, setIsVisisble] = useState(false)
  useEffect(() => {
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-external-store-subscription
    setIsVisisble(false)
    const clickHandler = (event: MouseEvent) => {
      // Only react to user-initiated navigation clicks.
      if (!event.isTrusted) return

      // Ignore command/control + click
      if (event.metaKey || event.ctrlKey) return
      const target = event.target
      if (
        typeof HTMLElement !== 'undefined' &&
        (target instanceof HTMLElement || target instanceof SVGElement)
      ) {
        const wrappingAnchor = target.closest('a')
        const href = wrappingAnchor?.getAttribute('href')

        // Skip nonstandard links
        if (
          !href ||
          wrappingAnchor?.hasAttribute('download') ||
          href.startsWith('javascript:') ||
          href.startsWith('mailto:') ||
          href.startsWith('tel:') ||
          href.startsWith('blob:') ||
          href.startsWith('data:')
        ) {
          return
        }

        // Skip new tabs
        const hrefTarget = wrappingAnchor?.getAttribute('target') ?? ''
        if (hrefTarget.toLowerCase() === '_blank') {
          return
        }

        // Skip external links
        if (href.startsWith('http') && !href.startsWith(window.location.origin)) {
          return
        }

        try {
          const hrefPathname = stripLocaleFromPathname(new URL(href, window.location.href).pathname)
          const currentPathname = stripLocaleFromPathname(window.location.pathname)

          if (hrefPathname !== currentPathname) {
            setIsVisisble(true)
          }
        } catch {
          return // Invalid URL
        }
      }
    }

    window.addEventListener('click', clickHandler)
    return () => {
      window.removeEventListener('click', clickHandler)
    }
  }, [pathname, searchparams])

  return isVisible ? <StyledInterstitial /> : null
}
